const gpApiClient = services =>
	typeof window === "undefined"
		? require("./server-side").default(services)
		: require("./client-side").default;

export default gpApiClient;
